import { render, staticRenderFns } from "./CreateDocumentDlg.vue?vue&type=template&id=e9dd2908&"
import script from "./CreateDocumentDlg.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports